const productSubscription = class extends HTMLElement {
  productForm: any;
  purchaseType: any;
  purchaseOptions: any;
  activeSellingPlan: any;
  sellingPlans: any;
  sellingPlanInput: any;
  sellingPlanSelectedLabel: any;
  variantSelector: any;
  swatchOptions: any;

  constructor() {
    super();
    this.productForm = this.closest('[data-product-form-form]');
    this.purchaseType = 'one-time';
    this.purchaseOptions = this.querySelectorAll(
      '[data-product-purchase-option]'
    );
    this.activeSellingPlan = '';
    this.sellingPlans = this.querySelectorAll('[data-selling-plan]');
    this.sellingPlanInput = this.querySelector(
      '[data-product-selling-plan-input]'
    );
    this.sellingPlanSelectedLabel = this.querySelector('[data-product-selling-plan-selected-label]');

    this.initSubscription();
  }

  initSubscription() {
    if (!this.productForm) {
      return;
    }

    this.variantSelector = this.productForm.querySelector('[name="id"]');
    this.swatchOptions = this.productForm.querySelectorAll(
      '[data-swatch-options]'
    );

    const activeSellingPlanEl = this.querySelector(
      '[data-selling-plan].active'
    );

    if (activeSellingPlanEl) {
      this.activeSellingPlan = activeSellingPlanEl.dataset.sellingPlanId;
    }

    this.initVariantSelector();
    this.initSwatchOptions();
    this.initPurchaseOptions();
  }

  initVariantSelector() {
    if (!this.variantSelector) {
      return;
    }

    this.variantSelector.addEventListener('change', (variantSelector) => {
      this.changeVariant(variantSelector.value);
    });
  }

  initSwatchOptions() {
    if (this.swatchOptions.size < 1) {
      return;
    }

    this.swatchOptions.forEach((swatchOption) => {
      const swatchObjects = swatchOption.querySelectorAll(
        '[data-swatch-object]'
      );

      swatchObjects.forEach((swatchObject) => {
        swatchObject.addEventListener('click', () => {
          this.changeVariant(swatchObject.dataset.variantId);
        });
      });
    });
  }

  initPurchaseOptions() {
    if (this.purchaseOptions.size < 1) {
      return;
    }

    this.purchaseOptions.forEach((purchaseOption) => {
      purchaseOption.addEventListener('change', () => {
        this.changePurchaseOption(purchaseOption);
      });
    });
  }

  changeVariant(variantId) {
    this.sellingPlans.forEach((sellingPlan) => {
      if (sellingPlan.dataset.sellingPlanVariant === variantId) {
        sellingPlan.classList.add('active');
        this.activeSellingPlan = sellingPlan.dataset.sellingPlanId;

        if (this.purchaseType === 'subscription') {
          this.setActiveSellingPlan();
        }
      } else {
        sellingPlan.classList.remove('active');
      }
    });
  }

  changePurchaseOption(purchaseOption) {
    this.purchaseType = purchaseOption.value;

    if (purchaseOption.value === 'one-time') {
      this.sellingPlanInput.removeAttribute('value');
    } else {
      this.setActiveSellingPlan();
    }

    this.sellingPlanSelectedLabel.classList.toggle('is-one-time', purchaseOption.value === 'one-time');
  }

  setActiveSellingPlan() {
    this.sellingPlanInput.setAttribute('value', this.activeSellingPlan);
  }
};

if (typeof window.customElements.get('product-subscription') === 'undefined') {
  window.customElements.define('product-subscription', productSubscription);
}
